import { render, staticRenderFns } from "./WorkTable979.vue?vue&type=template&id=e22aad70&scoped=true"
import script from "./WorkTable979.vue?vue&type=script&lang=js"
export * from "./WorkTable979.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22aad70",
  null
  
)

export default component.exports